import { forwardRef, createElement } from 'react';

function IconLedgerCardReservedEntry(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 3c.966 0 1.75.784 1.75 1.75v14.5A1.75 1.75 0 0119.25 21H4.75a1.75 1.75 0 01-1.732-1.499L19.25 19.5a.25.25 0 00.243-.193l.007-.057L19.499 6h-15v3.5h-1.5L3 4.75C3 3.784 3.784 3 4.75 3h14.5zM6.28 10.97a.75.75 0 01.073.976l-.073.084-1.719 1.719 5.689.001a.75.75 0 110 1.5l-5.69-.001 1.72 1.72a.75.75 0 01-.976 1.134l-.084-.073-3-3-.08-.094-.051-.081-.05-.116-.027-.103-.01-.089v-.094l.018-.124.03-.099.047-.099.054-.082.069-.08 3-3a.75.75 0 011.06 0zm10.97 4.53a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-3.5a.75.75 0 110-1.5h3.5zm0-3.5a.75.75 0 110 1.5h-8.5a.75.75 0 010-1.5h8.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var LedgerCardReservedEntry = /*#__PURE__*/forwardRef(IconLedgerCardReservedEntry);

export default LedgerCardReservedEntry;
//# sourceMappingURL=LedgerCardReservedEntry.js.map
